import React, { useState, useContext } from "react"
import {
  Navbar,
  Nav,
  NavbarBrand,
  Collapse,
  NavbarToggler,
  Button,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars, faUserCircle } from "@fortawesome/free-solid-svg-icons"
import { UserContext } from "../../contexts/UserContext"
import icon from "../../images/icon.png"
import "./header.scss"

const Header = () => {
  const [collapsed, setCollapsed] = useState(false),
    { data, status } = useContext(UserContext),
    name = data.fullname ? data.fullname.split(" ")[0] : "",
    dataIsEmpty = Object.entries(data).length === 0

  const toggleNavbar = () => setCollapsed(!collapsed)

  const handleSignout = async () => {
    localStorage.clear()
    window.location.pathname = "/"
  }

  return (
    <div>
      <Navbar expand="lg" className="text-capitalize header-navbar py-lg-0 px-lg-5">
        <NavbarBrand href="/" className="ml-lg-n1 fw-bolder">
          {icon && <img alt="Billgist Icon" src={icon} width="80px" />}
          <span className="text-secondary">Frugal Cloud</span> <span className="text-primary">Blog</span>
        </NavbarBrand>
        <NavbarToggler data-testid="toggler" onClick={toggleNavbar} className="navbar-toggler text-secondary">
          <FontAwesomeIcon icon={faBars} />
        </NavbarToggler>
        <Collapse isOpen={collapsed} navbar>
          {status === "resolved" && (
            <Nav className="ml-auto" navbar>
              {dataIsEmpty ? (
                <>
                  <NavItem>
                    <a href="/" className="fw-bold nav-link">
                      Home
                    </a>
                  </NavItem>
                  <NavItem>
                    <a href="/sign-in" className="nav-btn nav-link">
                      <Button size="sm" className="text-capitalize text-white" color="primary">
                        Sign In
                      </Button>
                    </a>
                  </NavItem>
                  <NavItem>
                    <a href="/sign-up" className="nav-btn nav-link">
                      <Button size="sm" className="text-capitalize text-white" color="primary">
                        Sign Up
                      </Button>
                    </a>
                  </NavItem>
                </>
              ) : (
                <>
                  {data.email_verified && (
                    <>
                      <NavItem>
                        <a className="nav-link fw-bold pt-0" href="/dashboard">
                          Dashboard
                        </a>
                      </NavItem>
                      <NavItem>
                        <a className="nav-link fw-bold pt-0" href="/aws-integration">
                          AWS Integrations
                        </a>
                      </NavItem>
                      <NavItem>
                        <a className="nav-link fw-bold pt-0 pr-lg-5" href="/notification">
                          Notifications
                        </a>
                      </NavItem>
                    </>
                  )}

                  <UncontrolledDropdown nav inNavbar className="d-lg-flex align-items-center">
                    <DropdownToggle nav className="d-flex align-items-center p-0 mt-0 mr-0">
                      {name}
                      {data.image ? (
                        <img
                          src={data.image.src}
                          className="rounded-circle ml-1"
                          width="40"
                          height="40"
                          alt="user profile avatar"
                        />
                      ) : (
                        <FontAwesomeIcon icon={faUserCircle} size="2x" className="pl-1" />
                      )}
                    </DropdownToggle>
                    <DropdownMenu end>
                      <a href="/settings" className="text-decoration-none">
                        <DropdownItem data-testid="settings">Account Settings</DropdownItem>
                      </a>
                      {data.email_verified && (
                        <>
                          <a href="/subscription" className="text-decoration-none">
                            <DropdownItem>Billing</DropdownItem>
                          </a>
                        </>
                      )}

                      <DropdownItem data-testid="logout" onClick={handleSignout}>
                        Sign Out
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </>
              )}
            </Nav>
          )}
        </Collapse>
      </Navbar>
      <div className="navbar-underline" />
    </div>
  )
}

export default Header
